import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { mdiChevronRight } from "@mdi/js";
import Icon from "@mdi/react";
import clsx from "clsx";

import { ISideBarType } from "models/Base";
import styles from "./style.module.scss";

type SideBarNavItemProps = {
  item: ISideBarType;
  isSideBarExpanded: boolean;
  setIsSideBarExpanded: (value: boolean) => void;
};

export default function SideBarNavItem({
  item,
  isSideBarExpanded,
  setIsSideBarExpanded
}: Readonly<SideBarNavItemProps>) {
  const { pathname } = useLocation();
  const isActive =
    item.link === pathname || !!item.children?.find((child) => pathname.includes(child.link!));

  const [showChildren, setShowChildren] = useState(isActive);

  useEffect(() => {
    if (isActive) {
      setShowChildren(isActive);
    }
  }, [isActive]);

  return (
    <NavLink
      key={item.title}
      to={item.link ? item.link : item.children![0].link!}
      onClick={() => {
        if (!isSideBarExpanded) {
          setIsSideBarExpanded(true);
        }
      }}>
      <div className={clsx(styles.item, isActive ? "text-sidebar" : "text-subtitle")}>
        {item.icon && <Icon path={item.icon} className="flex-none" />}
        {isSideBarExpanded && (
          <span className="flex-1 text-base whitespace-nowrap">{item.title}</span>
        )}
        {item.children?.length ? (
          <button
            onClick={(event) => {
              setShowChildren((prev) => !prev);
              event.preventDefault();
            }}>
            <Icon
              path={mdiChevronRight}
              className={clsx(
                styles.arrow,
                showChildren && !isSideBarExpanded && "!hidden",
                isActive ? "text-sidebar" : "text-subtitle",
                showChildren && "rotate-90"
              )}
            />
          </button>
        ) : null}
      </div>

      {item.children?.length && showChildren && isSideBarExpanded ? (
        <ul className="flex flex-col pl-10">
          {item.children.map((subItem) => (
            <NavLink
              key={subItem.link}
              to={subItem.link ?? ""}
              className={clsx(
                styles.item,
                pathname.includes(subItem.link!) ? "text-sidebar" : "text-subtitle"
              )}>
              {subItem.title}
            </NavLink>
          ))}
        </ul>
      ) : null}
    </NavLink>
  );
}
